/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Public_Host_HintInputs */

const cs_settings_office_public_host_hint = /** @type {(inputs: Settings_Office_Public_Host_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doména veřejného webu kanceláře (např. www.vase-rk.cz). Připraveno pro budoucí vlastní domény — nyní jen ukládáme hodnotu.`)
};

const en_settings_office_public_host_hint = /** @type {(inputs: Settings_Office_Public_Host_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain of the office's public website (e.g. www.your-office.cz). Prepared for custom domains later — for now this just stores the value.`)
};

/**
* | output |
* | --- |
* | "Domain of the office's public website (e.g. www.your-office.cz). Prepared for custom domains later — for now this just stores the value." |
*
* @param {Settings_Office_Public_Host_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_public_host_hint = /** @type {((inputs?: Settings_Office_Public_Host_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Public_Host_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_public_host_hint(inputs)
	return cs_settings_office_public_host_hint(inputs)
});